<template>
  <stats-wrapper
    :title="$t('titles.global.topVoting')"
    filters
    :loading="loading"
    @refresh="init"
  >
    <filters slot="filters" v-model="filters" @search="init" />
    <list slot="list" :data="topVoting" :pagination.sync="pagination" />
    <bar-chart
      v-if="!loading && chartData.length"
      slot="bar"
      :data="chartData"
    />
  </stats-wrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import StatsWrapper from '../StatsWrapper'
import Filters from './Filters'
import List from './List'
import BarChart from '@/components/widgets/chart/BarChart'
export default {
  name: 'TopVoting',
  components: {
    StatsWrapper,
    BarChart,
    Filters,
    List,
  },
  data() {
    return {
      filters: { typeRanking: 'score' },
      pagination: { hasMore: false, page: 1, rowsPerPage: 5, totalItems: 0 },
      loading: false,
    }
  },
  watch: {
    'pagination.page': {
      handler: function (val, oldVal) {
        if (val !== oldVal) this.init()
      },
    },
    'pagination.rowsPerPage': {
      handler: function (val, oldVal) {
        if (val !== oldVal) this.init()
      },
    },
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState({
      topVoting: (state) => state.stats.topVoting,
    }),
    chartData() {
      return this.topVoting.map((item) => {
        let result = {
          name: item.typeEventName,
          [this.$t('titles.global.votes')]: item.score,
          [this.$t('titles.global.average')]: item.rate,
        }
        if (item.playerName) result.name += ' - ' + item.playerName
        else if (item.teamName) result.name += ' - ' + item.teamName
        return result
      })
    },
  },
  methods: {
    ...mapActions({
      fetchTopVoting: 'stats/fetchTopVoting',
    }),
    init() {
      let query = {
        page: this.pagination.page,
        limit: this.pagination.rowsPerPage,
      }

      this.loading = true
      this.fetchTopVoting({ params: this.filters, query })
        .then((data) => {
          this.pagination.totalItems = data.paginate
            ? data.paginate.totalData
            : 0
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
